import React from 'react';

import GoogleMapReact from '../lazy-google-map-react';
import clsx from 'clsx';
import LocationIcon from '@/icons/location';
import googleMapApiLoader from '@/utility/map';

interface Center {
  lat: number;
  lng: number;
}

interface MapProps {
  center: Center;
  defaultZoom: number;
}

export const Map = (props: MapProps) => {
  return (
    <GoogleMapReact
      defaultZoom={props.defaultZoom}
      center={props.center}
      googleMapLoader={googleMapApiLoader}
    >
      <Marker lat={props.center.lat} lng={props.center.lng} />
    </GoogleMapReact>
  );
};

export default Map;

interface IMarkerProps {
  lat: number;
  lng: number;
}

const Marker: React.FC<IMarkerProps> = () => {
  return (
    <div>
      <div
        className={clsx(
          'items-center justify-center absolute transform cursor-pointer text-primary-500 hover:scale-125'
        )}
        style={{
          width: 40,
          height: 40,
          left: -20,
          bottom: 0,
          transition: 'transform 100ms',
        }}
      >
        <LocationIcon width={40} height={40} />
      </div>
    </div>
  );
};
